import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/wave-frequency-calculator',
  component: () => import('../../routes/WaveFrequencyCalculator.svelte'),
  card: {
    id: 'wave-frequency-calculator',
    title: 'Wave Frequency',
    description: "Calculate wave speed, frequency, and wavelength using v = f × λ. Solves any variable from the other two. Also computes period, angular frequency, and wave number.",
    icon: 'waves',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/wave-frequency-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Wave Frequency Calculator – Solve v = f × λ for Any Variable',
    description:
      'Free wave frequency calculator. Find wave speed, frequency, or wavelength from the wave equation v = f × λ. Also calculates period, angular frequency, and wave number.',
  },
};

export default meta;